module.exports = __webpack_public_path__ + "static/media/user.d4ff4286.svg";